import { Component, Input, OnInit, ViewChild } from '@angular/core';
import { ApiService } from 'src/app/shared/services';

@Component({
    selector: 'app-image-comparison',
    styleUrls: ['./image-comparison.component.scss'],
    templateUrl: './image-comparison.component.html'
})
export class ImageComparisonComponent implements OnInit {
    private readonly FIRST_INDEX = 0;
    private readonly SECOND_INDEX = 1;

    @ViewChild('comparisonElement', {static: true}) private readonly comparisonElement;
    @Input() private readonly images: string[];
    @Input() private maxHeight: string | number = null;
    @Input() handSet : boolean; 
    selectedData: any;
    showSection = true;
    designImages: any[] = [ 
      ];
      isBeforeImageLoaded = false;
      isAfterImageLoaded = false;
      hasBeforeImageError = false;
      hasAfterImageError = false
      

     constructor(private api:ApiService){}

    public ngOnInit(): void {

      this.api.getLandingDesignImages().subscribe((res:any[])=>{
        this.designImages = res.sort((a,b)=>a.rank - b.rank); 
      setTimeout(() => {
        
      // this.initComparison();
      this.selectSection(this.designImages[0]);
      }, 2000);
      })

    
    }
    onImageLoad(isBefore){
      if(isBefore){
        this.isBeforeImageLoaded = true;
      } else {
        this.isAfterImageLoaded = true;

      }
        if (this.isBeforeImageLoaded && this.isAfterImageLoaded) {
    setTimeout(() => this.initComparison(), 0); // Safe DOM init
  }
    }


    onImageError(isBefore) { 
      // if(isBefore){
      //   this.isBeforeImageLoaded = false;
      // this.hasBeforeImageError = true;

      // } else {
      //   this.isAfterImageLoaded = false;
      //   this.hasAfterImageError = true;

      // }
    }

    public getFirstImage(): string {
        return this.images[this.FIRST_INDEX];
    }

    public getSecondImage(): string {
        return this.images[this.SECOND_INDEX];
    }

    private initComparison(): void {

      const slider = document.querySelector(".image-comparison .slider");
      const beforeImage = document.querySelector(".image-comparison .actual-before-image") as any;
      const sliderLine = document.querySelector(".image-comparison .slider-line") as any;
      const sliderIcon = document.querySelector(".image-comparison .slider-icon") as any;
      
      slider.addEventListener("input", (e:any) => {
        let sliderValue = e.target.value + "%";
      
        beforeImage.style.width = sliderValue;
        sliderLine.style.left = sliderValue;
        sliderIcon.style.left = sliderValue;
      });
      
    }
    selectSection(p){
      // this.isBeforeImageLoaded = false;
      // this.isAfterImageLoaded=false;

        this.showSection = false;
        this.selectedData = p;
        this.showSection = true;
    }
}